import React, { useState, useEffect, useContext, useRef } from "react";
import { Form, Row, Col, Button, Table, Badge, Stack, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faEraser } from "@fortawesome/free-solid-svg-icons";

import { GET_LIST_RELATORIO } from "../../../services/Relatorio";
import { GET_CATEGORIA_ARVORE } from "../../../services/Categoria";

import { Context } from "context/AuthContext";

import HtmlPreview from "components/HTMLExtract";
import CategoriaSelector from "components/SelectCategorias";

import "./styles.scss";
import { set } from "jodit/esm/core/helpers";

const ContentRelatorio = () => {
  const valorInicial = {
    usuarioId: 0,
    categoria: "",
    CategoriasId: [],
    categoriaSuperior: "",
    enunciado: "",
    questaoId: 0,
    totalErros: 0,
    PageNumber: 1,
    PageSize: 25,
  };

  const { showLoader } = useContext(Context);
  const [filtro, setFiltro] = useState(valorInicial);
  const [filtroLimpo, setFiltroLimpo] = useState(false);
  const [questoes, setQuestoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [usuarios, setUsuarios] = useState([
    { label: "Selecione um usuário", value: "", id: "" },
  ]);

  const [categorias, setCategorias] = useState([]);

  // UseRef para evitar rolagem para o topo
  const tabelaRef = useRef(null);

  useEffect(() => {
    // Carregar dados iniciais
    loadData();
  }, []);


  const loadData = async () => {
    try {
      setLoading(true);
      // Executa ambas as requisições simultaneamente
      const [relatorioData, categoriaData] = await Promise.all([
        handleGetRelatorioQuestoes(),
        handleGetCategorias(),
      ]);

      if (relatorioData) {
        setQuestoes(relatorioData.value);
      }

      if (categoriaData) {
        setCategorias(categoriaData.value);
      }
    } catch (error) {
      console.error("Erro ao carregar os dados:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleGetCategorias = async () => {
    return await GET_CATEGORIA_ARVORE();
  };

  const handleGetRelatorioQuestoes = async () => {
    return await GET_LIST_RELATORIO(filtro);
  };


  const handleSaveFilter = async () => {

    setLoading(true);

    const data = await handleGetRelatorioQuestoes(filtro.CategoriasId);

    if (data) {
      setQuestoes(data.value);
    }
    setLoading(false);
  };

  const handleClearFilter = async () => {
    setFiltro(valorInicial);
    setFiltroLimpo(true);
    setLoading(true);
    const data = await GET_LIST_RELATORIO(valorInicial);

    if (data) {
      setQuestoes(data.value);
    }
    setLoading(false);
  };

  const handleCategoriaChange = (categorias) => {
    setFiltroLimpo(false);
    setFiltro((prevFiltro) => ({
      ...prevFiltro,
      CategoriasId: categorias,
    }));
  };
  return (
    <React.Fragment>
      <div className="relatorio-container-questoes" ref={tabelaRef}>
        <div className="relatorio-content-wrapper">
          <div className="relatorio-content">
            <Form className=" ms-3 p-2">
              <Form.Group as={Row} className="col-md-8">
                <Col sm="3">
                  <Form.Label column className="mb-3">
                    Categorias
                  </Form.Label>
                </Col>
                <Col className="categoria-content">
                  <CategoriaSelector
                    categorias={categorias}
                    onCategoriasChange={handleCategoriaChange}
                    filtroLimpo={filtroLimpo}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm="2"></Col>
                <Col sm="8" className="d-flex justify-content-start">
                  <Button
                    className="btn-filtro-relatorio me-3"
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSaveFilter();
                    }}>
                    <FontAwesomeIcon icon={faSearch} className="btn-icon" />
                    Filtrar
                  </Button>
                  <Button
                    className="btn-filtro-relatorio"
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      handleClearFilter();
                    }}>
                    <FontAwesomeIcon icon={faEraser} className="btn-icon" />
                    Limpar filtro
                  </Button>
                </Col>
              </Form.Group>
            </Form>
            <hr />
            {loading ? (
              <div className="loader-gif-container">
                <Spinner animation="border" role="status" className="loader-spinner" />
              </div>) : (
              <Table responsive="sm" bsPrefix="relatorio-table">
                <thead>
                  <tr>
                    <th>Total de X respondidas</th>
                    <th>Porcentagem de Erros</th>
                    <th>Categoria</th>
                    <th>Enunciado</th>
                  </tr>
                </thead>
                <tbody>
                  {questoes.length > 0 ? (
                    questoes.map((questao, index) => (
                      <tr key={index}>
                        <td>{questao.totalQuestao}</td>
                        <td>{questao.totalErros + "%"}</td>
                        <td>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            style={{
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}>
                            <Badge bg="secondary" text="white">
                              {questao.categoriaSuperior}
                            </Badge>
                            <Badge bg="secondary" text="white">
                              {questao.categoria}
                            </Badge>
                          </Stack>
                        </td>
                        <td>
                          <HtmlPreview
                            htmlContent={questao.enunciado}
                            mode="list"
                            className="relatorio-enunciado"
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        Nenhuma informação encontrada
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContentRelatorio;
